import {
  DOCUMENT_STATUS_FILTER_OPTIONS,
  DOCUMENT_STATUS_LABELS,
  formatDocumentStatusLabel,
} from '#/modules/imsMgmt/receipts/shared/documentStatus';

export const STOCK_TRANSFER_STATUS_LABELS = DOCUMENT_STATUS_LABELS;
export const STOCK_TRANSFER_STATUS_FILTER_OPTIONS = DOCUMENT_STATUS_FILTER_OPTIONS;

export const STOCK_NO_POLICY_OPTIONS = [
  { value: 'REMAINING_KEEP_OLD', label: '剩餘保留舊庫存編號' },
  { value: 'TRANSFERRED_KEEP_OLD', label: '轉出保留舊庫存編號' },
];

export function canEditStockTransferDraft(status) {
  return status === 'DRAFT';
}

export function canEditStockTransfer(status) {
  return canEditStockTransferDraft(status);
}

export function canEditStockTransferRemark(status) {
  return status === 'COMPLETED';
}

export function canSubmitStockTransfer(status) {
  return status === 'DRAFT';
}

export function canCancelStockTransfer(status) {
  return status === 'DRAFT';
}

export function canApproveStockTransfer(status) {
  return status === 'SUBMITTED';
}

export function canRejectStockTransfer(status) {
  return status === 'SUBMITTED';
}

export function formatStockTransferStatusLabel(status) {
  return formatDocumentStatusLabel(status);
}

export function formatStockNoPolicyLabel(policy) {
  const found = STOCK_NO_POLICY_OPTIONS.find((item) => item.value === policy);
  return found?.label ?? policy ?? '-';
}
